import moment from 'moment';

import { BAYS, BTSessionStatus, ClinicalRelationships, Roles } from '../../../../../../constants';
import { areUserRolesIn } from '../../../../../../helpers';
import { FORTA_ERROR, FORTA_ORANGE, FORTA_SUCCESS } from '../../../../../../utils/colors';

import type { Moment } from 'moment';
import type { IBTSession } from '../../../../../../utils/types';

export const formatSessionDateTime = (date: Moment | string) =>
  moment(date).format('MM/DD/YYYY - hh:mm A');

export function getSignatureStatusColor(
  showParentSignatureWarning: boolean,
  isSigned: boolean,
): string {
  if (showParentSignatureWarning) return FORTA_ERROR;
  if (isSigned) return FORTA_SUCCESS;
  return FORTA_ORANGE;
}

export function getSessionProviderRoleLabelTranslationKey(
  bay: string | null | undefined,
  clinicalRelationship: ClinicalRelationships | string | null | undefined,
): 'provider' | 'directServiceProvider' | 'behavioralTechnician' {
  if (bay === BAYS.BAY_6) {
    return 'provider';
  }
  if (clinicalRelationship === ClinicalRelationships.HomeBcba) {
    return 'directServiceProvider';
  }
  return 'behavioralTechnician';
}

export function shouldShowMakeNoteEditableButton(
  roles: Roles[],
  session: IBTSession | null,
): boolean {
  return Boolean(
    areUserRolesIn(roles, [Roles.Admin]) &&
    session?.id &&
    (session.status === BTSessionStatus.Completed ||
      session.status === BTSessionStatus.AwaitingFinalization ||
      session.status === BTSessionStatus.AwaitingGuardianSignature ||
      session.status === BTSessionStatus.EditsRequested ||
      session.status === BTSessionStatus.AwaitingReview),
  );
}

export function shouldShowBackdateForm(roles: Roles[], session: IBTSession | null): boolean {
  return Boolean(
    areUserRolesIn(roles, [Roles.Admin]) &&
    session?.id &&
    session.status === BTSessionStatus.Started,
  );
}

export function shouldShowDeleteButton(
  roles: Roles[],
  email: string,
  session: IBTSession | null,
): boolean {
  return Boolean(
    !areUserRolesIn(roles, [Roles.LimitedAccessGuardian]) &&
    session?.id &&
    session?.status === BTSessionStatus.Started &&
    (session?.session_provider?.email === email || areUserRolesIn(roles, [Roles.Admin])),
  );
}
